import { useEffect, useState } from 'react';

export default function useMobile() {
	const [mobile, setMobile] = useState(false);
	const [inited, setInited] = useState(false);

	useEffect(() => {
		function handler() {
			setMobile(window.screen.width <= 768);
			setInited((prev) => {
				if (!prev) return true;
				return prev;
			});
		}

		handler();

		addEventListener('resize', handler);
		return () => {
			removeEventListener('resize', handler);
		};
	}, []);

	return { isMobile: mobile, inited };
}
